import { connect } from 'react-redux';
import OrderList from '../components/OrderList/OrderList';
import * as actions from '../redux/actions/OrderList';
import { getUser } from '../redux/actions/AccountSetting';
import { jobCompleted } from "../redux/actions/Broadcasting";
import { initializeMessage } from '../redux/actions/Common';
import { getSalesforceConfig } from "../redux/actions/Salesforce";
import { push } from 'react-router-redux';

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  orderList: state.orderList.orderList,
  pageInfo: state.orderList.pageInfo,
  isLoading: state.orderList.isLoading,
  // Salesforce関連はletterOrderListに定義しているためorで取得しています。
  message: state.orderList.message || state.broadcasting.jobSuccessMessage || state.letterOrderList.message || state.followCallOrder.message,
  errorMessage: state.orderList.errorMessage || state.letterOrderList.errorMessage || state.followCallOrder.errorMessage,
  isPostingSalesforceSync: state.letterOrderList.isPostingSalesforceSync || state.followCallOrder.isPostingSalesforceSync,
  currentMonthOrdersOverview: state.orderList.currentMonthOrdersOverview,
  isLoadingCurrentMonthOrdersOverview: state.orderList.isLoadingCurrentMonthOrdersOverview,
  selectYearMonthOrdersOverview: state.orderList.selectYearMonthOrdersOverview,
  isLoadingSelectYearMonthOrdersOverview: state.orderList.isLoadingSelectYearMonthOrdersOverview,
})

const mapDispatchToProps = dispatch => ({
  getOrderList(data) {
    dispatch(actions.getOrderList(data))
  },

  getUserInfo() {
    dispatch(getUser());
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getCurrentMouthOrdersOverview(data) {
    dispatch(actions.getCurrentMouthOrdersOverview(
      {
        ...data,
        targets: ["letter_order_address_count", "follow_call_order_address_count"],
      }
    ));
  },

  getSelectYearMonthOrdersOverview(data) {
    dispatch(actions.getSelectMouthOrdersOverview(
      {
        ...data,
        targets: ["letter_order_address_count", "follow_call_order_address_count"],
      }
    ));
  },

  getSalesforceConfig() {
    dispatch(getSalesforceConfig());
  },

  initializeMessage() {
    dispatch(initializeMessage());
  },

  jobCompleted(userId) {
    dispatch(jobCompleted(userId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderList);



// WEBPACK FOOTER //
// ./src/containers/OrderList.js